import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Page3.css';

import bg_map from './../assets/page5/05_see_spray_Map.png';

function Page3_1() {
  const navigate = useNavigate();

  return (
    <div className="page3-container">
      <img src={bg_map} alt='' />
      <div className="back-button" style={{ bottom: '119px', left: '75px', width: '76px', height: '50px' }}  onClick={() => navigate('/page5')}></div>
    </div>
  );
}

export default Page3_1;
